<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100"
                        fixed-header height="calc(100vh - 300px)">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ID }}</td>
                                <td>{{ item.StorageID | display_value(storages, 'ID', 'Name') }}</td>
                                <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                                <td class="text-right">{{ item.ValueMin | currency('', 1) }}</td>
                                <td class="text-right">{{ item.ValueMax | currency('', 1) }}</td>
                                <td class="text-right">{{ item.Amount | currency }}</td>
                                <td>
                                    {{ item.ModifiedDate | display_date}}
                                </td>
                                <td class="text-center">
                                    <table-action-buttons :actions="getItemActions(item)"></table-action-buttons>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Chi tiết phí cân</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                  <v-flex lg6>
                    <v-select outlined dense label="Kho nhận" class="input-group--focused" v-model="currentItem.StorageID" :items="storages" item-value="ID" item-text="Name"></v-select>
                  </v-flex>
                  <v-flex lg6>
                    <v-select outlined dense label="Loại hàng" class="input-group--focused" v-model="currentItem.ProductType" :items="product_types" item-value="ID" item-text="Name"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg4>
                    <h-currency-input label="Từ (kg)" v-model="currentItem.ValueMin" :decimal="1" class="input-group--focused"></h-currency-input>
                  </v-flex>
                  <v-flex lg4>
                    <h-currency-input label="Đến (kg)" v-model="currentItem.ValueMax" :decimal="1" class="input-group--focused"></h-currency-input>
                  </v-flex>
                  <v-flex lg4>
                    <h-currency-input label="Đơn giá" v-model="currentItem.Amount" :decimal="0" class="input-group--focused"></h-currency-input>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
              <v-btn @click="editItem" v-if="adminRole || managerRole">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import _ from "lodash";
    
    export default {
        props: ["currentUID", "showDialog"],
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                viewName: "feeWeight_list",
                dialogItem: false,
                headers: [
                    {
                        text: this.$t('table_headers.id'),
                        value: "ID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.storage'),
                        value: "StorageID",
                        filterable: true,
                        values: [],
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: this.$t('table_headers.product_type'),
                        value: "ProductType",
                        filterable: true,
                        values: [],
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: this.$t('table_headers.fee_from_kg'),
                        value: "ValueMin",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.fee_to_kg'),
                        value: "ValueMax",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.amount'),
                        value: "Amount",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.modified_date'),
                        value: "ModifiedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            loading() {
              this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.adminRole && !this.managerRole});
            },
            showDialog() {
                if(this.currentUID) {
                    this.dialogItem = this.showDialog;
                }
            },
            storages() {
                let header_item = _.find(this.headers, { value: "StorageID" });
                if (header_item) {
                    header_item.values =
                    _.map(this.storages, (item) => {
                        return {
                        value: item.ID,
                        name: item.Name,
                        };
                    }) || [];
                }
            },
            product_types() {
                let header_item = _.find(this.headers, { value: "ProductType" });
                if (header_item) {
                    header_item.values =
                    _.map(this.product_types, (item) => {
                        return {
                        value: item.ID,
                        name: item.Name,
                        };
                    }) || [];
                }
            }
        },
        computed: {
            ...mapState({
                items: state => state.feeWeight.all.data,
                total_rows: state => state.feeWeight.all.total,
                loading: state => state.feeWeight.loading,
                currentItem: state => state.feeWeight.selected,
                storages: state => state.storage.all.data,
                product_types: state => state.productType.all.data,
            }),
            adminRole() {
                return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
            },
            managerRole() {
                return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Manager;
            }
        },
        methods: {
            getItemActions(item) {
                return [
                    { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                    { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !(this.adminRole || this.managerRole), onClick: () => this.deleteItem(item.ID) }
                ];
            },
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                };
                param.filter.push({
                    column: "UID",
                    value: this.currentUID ? this.currentUID : 0,
                    condition: "equal"
                });
                this.$store.dispatch("feeWeight/getList", param);
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (id) {
                if(!id) {
                    this.$store.commit("feeWeight/setDetail", {'ID': id});
                }
                else {
                    this.$store.dispatch("feeWeight/getDetail", id);
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                this.$store.dispatch("feeWeight/setDetail", {
                    'data': {
                        ...this.currentItem,
                        UID: this.currentUID ? this.currentUID : 0,
                    },
                    'id': this.currentItem.ID
                });
                this.dialogItem = false;
            }
        },
        mounted() {
            this.$store.dispatch("storage/getList");
            this.$store.dispatch("productType/getList");
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: false});
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("feeWeight/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
